// This is the default Pocketmags Plus Product info to show on every CLP
const defaultPocketmagsPlusCLPProductInfo = {
  type: 'POCKETMAGSPLUS',
  category_id: '',
  fourDigitCode: 'PLUS',
  hasFreeGift: false,
  id: '666-666',
  image: '/pocketmagsplus/image.png?fm=png&auto=format&w=360&mask=corners&corner-radius=20,20,20,20&mask-bg=0FFF&border=1,070707',
  isDelete: 0,
  product_id: '2599',
  sku: 'Pocketmags Plus+',
  term: 'pocketmagsplus',
  title: 'Pocketmags Plus',
  typeName: 'POCKETMAGSPLUS',
  url: 'magazines/pocketmagsplus',
  delivery: 'UK,International,ROW,EU',
  category: '',
  subCategory: ''
}

export function insertPocketmagsPlusInCLPProductList({ data, position, enabled, page }) {
  // console.log('insertPocketmagsPlusInCLPProductList INPUT data=', data)
  // console.log('insertPocketmagsPlusInCLPProductList position=', position)
  // console.log('insertPocketmagsPlusInCLPProductList enabled=', enabled)
  // console.log('insertPocketmagsPlusInCLPProductList page=', page)

  // Pocketmags Plus CLP logic has been disabled from M1 Category admin
  // No position has been specified
  // No product returned
  // The current page is not the First one
  // Do nothign and return the data
  if (!enabled || !position || data.length === 0 || page > 1) {
    return data
  }

  // Insert the new Pocketmags Plus product in the CLP list
  // If the list contains less offers that specifiec in position, the new prod will be added at the end of the list
  const newData = [...data]
  newData.splice(position - 1, 0, defaultPocketmagsPlusCLPProductInfo)
  // console.log('insertPocketmagsPlusInCLPProductList OUTPUT data=', newData)

  return newData
}

export const availablePocketmagsPlusTitles = [
  'Sailing Today',
  'Bow International',
  'Sporting Rifle',
  'Airgun Shooter',
  'Clay Shooting',
  'Sp Rifle Rifles & Ammo',
  'Sp Rifle Deer and Antelope',
  'Sp Rifle Big Game',
  'Saga Magazine',
  'Build It',
  'Clay Shooting with the Experts',
  'The Christmas Magazine',
  'Boxing Monthly',
  'Sp Rifle Vermin & Varminting',
  'Mini World',
  'Ships Monthly',
  'Deer Stalking Bible',
  'Practical Poultry',
  'WW Magazine UK',
  'Procycling',
  'Edge',
  'Total Film',
  'FLYER',
  'Federal Jobs Digest',
  'Shoot in Scotland',
  'Triumph World',
  'MG Enthusiast',
  'Jaguar World',
  'Airsoft Action',
  'Italia! Guide',
  'Motorsport News',
  'Sp Rifle Book of Foxing',
  'Sporting Rifle Books',
  'Old Glory Magazine',
  'Professional Beauty',
  'Aesthetic Medicine',
  'TGO - The Great Outdoors Magazine',
  'Boxing News',
  '911 & Porsche World',
  'Classic Porsche',
  'Performance Mini',
  'Performance BMW',
  'GT Porsche',
  'Performance VW',
  'Retro Cars',
  'Banzai',
  'BMW Car',
  'Bass Player UK',
  'Cage & Aviary Birds',
  'Trucking Magazine',
  'Coast',
  'Psychologies',
  'The Rugby Paper',
  'The Non-League Football Paper',
  'The Football League Paper',
  'The Cricket Paper',
  'Late Tackle Football Magazine',
  'Artists & Illustrators',
  'Britain',
  'Classic Boat',
  'Cruise International',
  'Racecar Engineering',
  'Yachts & Yachting',
  'Your Dog',
  'Your Cat',
  "Reader's Digest",
  'Hello! Magazine',
  'Classic Car Buyer',
  'Tractor & Machinery',
  'Park Home & Holiday Caravan',
  'Tractor & Farming Heritage Magazine',
  'Heritage Commercials Magazine',
  'Airgun Fieldcraft',
  'Classic Van & Pick-up',
  'Classic & Vintage Commercials',
  'Classic Car Mart',
  'Custom Car',
  'Classic Plant & Machinery',
  'Stationary Engine',
  'Classic Massey',
  'Practical Pigs',
  'Truckstop News',
  'Ford & Fordson',
  'Classic Truck',
  'Practical Motorhome',
  'FourFourTwo',
  'Practical Caravan',
  'Stuff',
  'What HiFi',
  'Vintage Roadscene',
  'World of Ships',
  'The Smallholder',
  'Car Mechanics',
  'Match',
  'Outdoor Fitness & Adventure',
  'Sea Angler',
  'Top Sante',
  'Your Horse',
  'Crafts Beautiful',
  'Veggie Magazine',
  "Let's Knit",
  'Health & Wellbeing',
  'Great British Food',
  'Sew',
  'Natural Health',
  'Homemaker',
  'Grow Your Own',
  'Soul & Spirit',
  'Shooting Sports',
  'Teach Primary',
  'Classic Motoring',
  'Gunmart',
  'Teach Early Years',
  'Modern Home',
  'Teach Secondary',
  'Speciality Food',
  'Making Money',
  'Sports Insight',
  '25 Beautiful Homes',
  'Amateur Gardening',
  'Amateur Photographer',
  'Anglers Mail',
  'Chat',
  'Chat Its Fate',
  'Chat Specials',
  'Country Homes & Interiors',
  'Country Life',
  'Cycling Weekly',
  'Golf Monthly',
  'Homes & Gardens',
  'Horse & Hound',
  'Ideal Home',
  'Living Etc',
  'Marie Claire',
  'Motorboat & Yachting',
  'Mountain Bike Rider',
  'Pick Me Up',
  'Pick Me Up! Special',
  'Practical Boatowner',
  'Rugby World',
  'Shooting Gazette',
  'Shooting Times & Country',
  'Sporting Gun',
  'Style at Home',
  'The Field',
  'TV & Satellite Week',
  'TV Times',
  'Volksworld',
  'VW Camper',
  "What's on TV",
  'Woman',
  'Womans Own',
  "Woman's Own Lifestyle Special",
  "Woman's Weekly",
  'Womans Weekly Fiction Special',
  'Woman & Home',
  'Woman & Home Feel Good Food',
  'Simply Woman & Home',
  'World Soccer',
  'Yachting Monthly',
  'Yachting World',
  'Racing Ahead',
  '3D World',
  'Classic Ford',
  'Classics Monthly',
  'Computer Arts',
  'Computer Music',
  'Digital Camera World',
  'Fast Car',
  'Fast Ford',
  'Future Music',
  'Guitar Techniques',
  'Guitarist',
  'ImagineFX',
  'Linux Format',
  'MacFormat',
  'Mini Magazine',
  'net',
  'N-Photo',
  'Official Xbox Magazine (UK Edition)',
  'PC Gamer (UK Edition)',
  'PhotoPlus',
  'PLAY Magazine',
  'SFX',
  'SFX Special Editions',
  'T3',
  'Total Guitar',
  'Windows Help & Advice',
  'Jaguar Enthusiast',
  'Craft Business',
  'Gluten-Free Heaven',
  'Mac|Life',
  'Maximum PC',
  'PC Gamer (US Edition)',
  'Official Xbox Magazine (US Edition)',
  'Photography Week',
  'Technology and Innovation',
  'VWt Magazine',
  'OK! Magazine',
  "Woman's Weekly Living Series",
  'delicious. Magazine',
  'Practical Photoshop',
  'Healthy Food Guide',
  'Performance Audi Magazine',
  'Railways of Britain',
  'Vintage Roadscene Archive',
  'China Report',
  'PaperCrafter',
  'Checkpoint Magazine',
  'Paleo Diet Bible',
  'Computer Active',
  'PC Pro',
  "Men's Fitness",
  "Women's Fitness",
  'Cyclist',
  'Evo',
  'Octane',
  'Auto Express',
  'Viz',
  'Fortean Times',
  'Storytime',
  'World Cup Guide Special',
  'Park and Holiday Home Inspiration magazine',
  "Harper's Bazaar",
  'Best',
  'Cosmopolitan',
  'Country Living',
  'Elle',
  'Elle Decoration',
  'Esquire',
  'Good Housekeeping',
  'House Beautiful',
  'Inside Soap',
  "Men's Health",
  'Prima',
  'Red',
  'Real People',
  "Runner's World",
  "Women's Health",
  'Newsweek International',
  'Hairdressers Journal',
  'Classic Jaguar',
  'The English Home',
  'The English Garden',
  'Discover Britain',
  'Electronic Sound',
  'Long Live Vinyl',
  'SciFiNow',
  'National Geographic Traveller (UK)',
  '3D Artist',
  'All About History',
  'All About Space',
  'How It Works',
  'Retro Gamer',
  'Total 911',
  'Web Designer',
  'Airbrush Step by Step',
  "Let's Get Crafting",
  'Minecraft World',
  'The Oldie',
  'Wanderlust',
  'Healthy Diet',
  'ClayCraft',
  'First News',
  'Digital Photographer',
  'History of War',
  'iCreate',
  'Classic Rock',
  'Metal Hammer',
  'Prog',
  'Rolls-Royce & Bentley Driver',
  'Profi International',
  "Essential iPhone & iPad Magazine inc. BDM's iOS Guides",
  "BDM's macOS User Guides",
  "BDM's Windows User Guides",
  "BDM's Android User Guides",
  'Vintage Rock Presents',
  'Classic Pop Presents',
  'Real Homes Magazine',
  'Period Living Magazine',
  'Homebuilding & Renovating Magazine',
  "BDM's Coding User Guides",
  "BDM's For Seniors User Guides",
  "BDM's Photography User Guides",
  "BDM's Photoshop User Guides",
  'Landscape Photography Guidebook',
  'GoPro - The Complete Guide',
  'The Windows 10 Manual',
  'Black & White Photography Guidebook',
  'Digital Photography - The Complete Guide',
  'The Canon Camera Manual',
  'Windows 10 - The Beginners Guide',
  'Complete Raspberry Pi',
  'Adobe Photoshop - The Complete Guide',
  'The Adobe Photoshop Lightroom Manual',
  'Royal Bookazine',
  'Global Franchise',
  'Make It Today',
  'What Franchise',
  'The Bowie Years',
  'Slim Fit & Healthy',
  'Ultimate Supercar',
  'The Racing Paper',
  'Simply Vegan',
  'The Royal Family Specials',
  'Vegan Food & Living Cookbook',
  'WhatsApp Guides',
  'World of Warships',
  'Whisky Magazine',
  'Gin Magazine',
  'Modern Home Magazine',
  'The Pattern Pages Sewing Magazine',
  'The Beatles Years',
  'Future Guides & Specials',
  'On the Buses',
  'K-Pop Superstars',
  'Pop Stars',
  'The History Anthology',
  'Smug Bear',
  'American Whiskey Magazine',
  'Paint & Draw: Watercolours',
  'How Your Body Works',
  '101 Places to Visit Before You Die',
  'The Ultimate Guide to Bathrooms',
  'Extreme Animals',
  '45 Crochet Patterns',
  'William & Harry',
  'Simply Beautiful Gardens',
  'Saltwater Living',
  "Women's Fitness Guides",
  "Men's Fitness Guides",
  'Improve Your Health',
  'Change Your Life',
  'Stuff Gadget Guide',
  'Improve Your Photography',
  'Modern Barber',
  'British Icons',
  'Boxing News Presents',
  'Professional Beauty & HJ Ireland',
  'Farm Machinery',
  'Amateur Photograper Premium Edition',
  'Ford Memories',
  'Jaguar Memories',
  'MG Memories',
  'Military Trucks Archive',
  'Modern Conflict',
  'War at Sea',
  'World Soccer Presents',
  'Fishing News',
  'Ford & Fordson Tractor Collection',
  'Pure Performance',
  'Old Glory Archive',
  'All About History Book of Greatest Battles',
  'All About History Book Of The Renaissance',
  'All About History Book of Assassinations',
  'All About History Book of Templars',
  "All About History's The History of Paganism",
  'Car Mechanic Bargain Cars',
  'BIKE Magazine',
  'All About History Book of Anglo Saxons',
  'Just CrossStitch',
  'Country Sampler',
  "Quilter's World",
  'Crochet World',
  'Crochet!',
  'Mountain Flyer',
  'Alpinist',
  'Backcountry',
  'Good Old Days',
  'Farmhouse Style',
  'Jeunessima Magazine',
  'Lose Weight Feel Great',
  'All About History Age of Discovery',
  'New Magazine',
  'Beautifully British',
  'Women Fitness',
  'Boys Ride Too',
  'Huck',
  'Little White Lies',
  'All About History: Story of World War II',
  'All About History: The Space Race',
  'About History Bookazine',
  'All About Space Bookazine',
  'Complete Manual Bookazine',
  'Creative Bookazine',
  'Decanter Bookazine',
  'Field Sports Bookazine',
  'Film Bookazine',
  'Future Genius Bookazine',
  'Gaming Bookazine',
  'History of War Bookazine',
  'Home Interests Bookazine',
  'How It Works Bookazine',
  'Lifestyle Bookazine',
  'Misc Bookazine',
  'Music Magazine',
  'Photography Bookazine',
  'Real Crime Bookazine',
  'Sport Bookazine',
  'Technology Bookazine',
  'Total 911 Bookazine',
  'World of Animals Bookazine',
  'Seniors Bookazine',
  'Best of British Leyland',
  'Sea Angler Guides',
  'Total Ford',
  'Philosophy Now',
  'MoneyWeek',
  'Classics World European',
  'Classics World German',
  'Classics World Japanese',
  'Car Mechanics Expert',
  'Motorsport Moments',
  'Retromotive',
  'Engage4x4',
  'The Guardian Newspaper'
]
